<template>
  <div id="app">
    <router-view v-if="!loaded" />
    <div v-if="!isWX">
      <div style="padding: 30vh 0;">
        <h1 style="margin-top: 0">网站即将上线</h1>
        <h1>敬请期待</h1>
      </div>
      <div>
        <h2>广州明煜视觉科技有限公司</h2>
        <h2><a style="color: #2c3e50" href="http://www.beian.miit.gov.cn/">粤ICP备20008362号-1</a></h2>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import { Toast } from 'vant'
import axios from 'axios'
const config = window.config
export default {
  name: 'App',
  computed: mapState([
    'user'
  ]),
  data() {
    return {
      loaded: true,
      isWX: true,

    }
  },
  beforeMount: function() {
    // dev
    // this.isWX = this.isWeiXin()
    // if (this.isWX) {
    //   this.initWx()
    //   Toast.loading({
    //     message: '加载中...',
    //     duration: 0,
    //     forbidClick: true,
    //   });
    // } else {
    //   document.title = '明煜视觉'
    //   window.location.href = 'https://my-eye.com.cn/web'
    // }
      // dev
    this.getUserByToken()

  },
  methods: {
    getUser: function () {
      // this.getUserByWX()
      const token = localStorage.getItem('token')
      if (token) {
        this.getUserByToken()
      } else {
        this.getUserByWX()
      }
    },
    closeLoad: function () {
      this.loaded = false
      Toast.clear()
    },
    getUserByWX: function (){
      const code = this.getQueryVariable('code')
      let action = 'signin'
      console.log(action)
      this.$store.httpDispatch({})(action, {
        code
      }).then((res) => {
        this.closeLoad()
        const { code, data } = res.data
        if (code === 0) {
          if (!data.user.mobile) {
          }
          data.tokenExpiredAt = new Date(data.tokenExpiredAt)
          localStorage.setItem('token', data.token)
          localStorage.setItem('tokenExpiredAt', data.tokenExpiredAt.getTime())
          this.$store.commit('ACCOUNT_RESTORE', {
            tokenExpiredAt: data.tokenExpiredAt,
            token: data.token
          })
          this.$store.dispatch('setUser', { user: data.user })
        } else {
          if (data) {
            return Toast({
              message: data.msg,
              duration: 3000
            })
          }
        }
      }).catch((err) => {
        this.closeLoad()
        console.log(err)
      })

    },
    getUserByToken: function () {
      this.$store.httpDispatch({})('getUserInfo').then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.closeLoad()
          if (!data.user.mobile) {
          }
          this.$store.dispatch('setUser', { user: data.user })
        } else {
          localStorage.clear('token')
          localStorage.clear('tokenExpiredAt')
          this.getUser()
        }
      }).catch((err) => {
        localStorage.clear('token')
        localStorage.clear('tokenExpiredAt')
        console.log(err)
        this.getUser()
      })
    },
    getQueryVariable: function (variable) {
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
       }
       return(false);
    },
    isWeiXin () {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_') {
        return true;
      } else {
        return false;
      }
    },
    initWx () {
      let path = '/api/signature'
      const that = this
      axios.get(path, {
        params: {
          url: location.href
        }
      })
        .then((res) => {
          const { code, data } = res. data
          if (code === 0) {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: config.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature,// 必填，签名
              jsApiList: ['chooseImage', 'uploadImage', 'openLocation', 'getLocation'] // 必填，需要使用的JS接口列表
            });
          }
        })
      wx.ready(function(){
        console.log('wx ready')
        that.getUser()
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      });
      wx.error(function(res){
        console.log(res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      })
    }
  }
}
</script>
<style lang="less">
body {
  margin: 0 0;
  padding: 0 0
}
@primary_blue: #2665FF;
.van-hairline--bottom::after {
  border-bottom-width: 0;
}
.van-nav-bar__title  {
  margin-left: 15%;
  font-size: 20px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #112950;
  background: linear-gradient(180deg, @primary_blue 50%, #fff 0%);
  min-height: 100vh;
  input,button,select,textarea{outline:none}
  select {
    -webkit-appearance: none;
  }
}
.user-cell-group {
  .van-icon {
    img {
      position: relative;
      top: 3px;
    }
  }
  .van-cell {
    padding: 15px 20px;
    .van-cell__title {
      span {
        font-size: 16px;
      }
    }
  }
}
.van-tabbar {
  height: 80px;
  background: #ebebeb;
  .van-tabbar-item {
    font-size: 15px;
  }
}
.home-page {
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-size: cover;
  .bind-phone-title {
    padding-left: 10px;
    span {
      color: #999
    }
  }
  .user-cell {
    text-align: left;
    padding: 20px 20px;
    border-radius: 10px;
  }
  .user-info {
    text-align: center;
    height: 130px;
    padding-top: 20px;
    line-height: 25px;
    span {
      color: #fff;
      font-size: 16px;
    }
    img.headimgurl {
      width: 80px;
      height: 80px;
      position: relative;
      border-radius: 50%;
    }
  }
  .user-cell-group {
    flex: 1;
    padding: 50px 10px;
  }
}
.myopia-nav {
  display: flex;
  padding-top: 10px;
  margin-bottom: 20px;
  .van-icon {
    width: 40px;
    box-sizing: border-box;
    padding: 10px 10px;
  }
  .nav-title {
    color: #112950;
    font-size: 20px;
    line-height: 36px;
    flex: 1;
  }
}
.button-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 20px 30px 50px;
  box-sizing: border-box;
  border-top: 1px solid #e7e7e7;
}
.button-footer-nofixed {
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 20px 10px 50px;
  box-sizing: border-box;
}
.primary-btn {
  height: 50px;
  font-size: 19px;
  background: @primary_blue;
  line-height: 50px;
  border-radius: 10px;
  width: 100%;
}
.van-calendar__confirm, .block-btn {
  height: 50px;
  font-size: 19px;
  line-height: 50px;
  margin-top: 20px;
  border-radius: 10px;
  width: 100%;
}
.top-right-radius {
  // border-top-right-radius: 30px;
  background: #fff;
}
#nav {
  padding: 30px;
  position: fixed;
  top: 0;
  width: 100vw;
  background: #fff;
  box-sizing: border-box;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#__vconsole .vc-toolbar, #__vconsole .vc-switch {
  bottom: 200px!important;
}
</style>
